import React from 'react';
import {
	playerAvatarImgClassName,
	playerListAvatarImgDimensionsStyle,
	playerListAvatarWrapperStyle
} from '../../../utils/avatarClassNames';

/** Player thumbnail — same markup as PlayersProfileStatsTable on /players. */
export default function PlayerListAvatar({ imageUrl, firstName, lastName }) {
	if (!imageUrl) return null;

	const name = `${firstName || ''} ${lastName || ''}`.trim();

	return (
		<div style={playerListAvatarWrapperStyle}>
			<img
				className={playerAvatarImgClassName}
				src={imageUrl + '?w=50&h=50'}
				alt={name}
				style={playerListAvatarImgDimensionsStyle}
			/>
		</div>
	);
}
